const detectedBasePath = (() => {
  if (typeof window === "undefined") return "";

  const configured = window.__KALOPSIA_ACCOUNTS_BASE_PATH__;
  if (typeof configured === "string") {
    return configured.replace(/\/$/, "");
  }

  const pathname = window.location.pathname;
  return pathname === "/accounts" || pathname.startsWith("/accounts/")
    ? "/accounts"
    : "";
})();

export const APP_BASE_PATH = detectedBasePath;

export const API_ORIGIN = (() => {
  if (typeof window === "undefined") return "";

  const configured = window.__KALOPSIA_ACCOUNTS_API_ORIGIN__;
  if (typeof configured === "string" && configured.trim()) {
    return configured.replace(/\/$/, "");
  }

  const hostname = window.location.hostname;

  if (hostname === "demo.kalopsia.pro") {
    return window.location.origin;
  }

  if (
    hostname === "cartofisserie.kalopsia.pro" ||
    hostname.endsWith(".cartofisserie.ro")
  ) {
    return "https://cartofisserie.kalopsia.pro";
  }

  return "https://rapoarte.kalopsia.pro";
})();

export function withAppBase(path) {
  const suffix = String(path || "").startsWith("/") ? path : `/${path}`;
  return `${APP_BASE_PATH}${suffix}`;
}
